import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import PageContent from '../PageContent';
import GlycemicIndexBox from './GlycemicIndexBox';
import DrGuideBox from './DrGuideBox';
import DietBox from './DietBox';
import ExerciseBox from './ExerciseBox';
import InsulinBox from './InsulinBox';
import Division from 'components/common/Division';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';
import Section from 'components/common/Section';
import DIRECTION_HORIZONTAL from 'constants/DIRECTION_HORIZONTAL';
import Segment from 'components/common/Segment';
import Dot from 'components/common/Dot';
import useOverview from 'hooks/communication/useOverview';
import React from 'react';
import Recoil from 'recoil';
import * as AppStore from 'stores/AppStore';

import DataRatio from '../DataRatio';
import OverviewTabs from './OverviewTabs';
import useCategorizedPages from 'hooks/app/useCategorizedPages';
import PageOutlet from '../PageOutlet';

import './Overview.css';
import useNavAction from 'hooks/actions/useNavAction';
import FocusableButton from 'components/common/FocusableButton';
import useNavigation from 'hooks/app/useNavigation';

const category = 'Overview';
export default function Overview(props) {
  const {
    renderAll,
    front,
    ...rest
  } = props || {};

  const {
    requestOverview,
  } = useOverview();

  const [data, setData] = React.useState({});
  const period_start = Recoil.useRecoilValue(AppStore.assets.period_start);
  const period_end = Recoil.useRecoilValue(AppStore.assets.period_end);
  const patient_no = Recoil.useRecoilValue(AppStore.assets.patient_no);
  React.useEffect(() => {
    if (!patient_no) return;
    requestOverview({
      patient_no,
      search_start_time: period_start,
      search_end_time: period_end,
    }, (success, data) => {
      if (success) {
        setData(() => data);
      } else {
        setData(() => ({}));
      }
    });
  }, [period_end, period_start, patient_no, requestOverview]);

  const pages = useCategorizedPages(category);

  const {
    data_reliability,
    data_reliability_yn,
    active_data_reliability,
    meal_cnt,
    meal_day_cnt,
    insulin_data_reliability,
  } = data || {};

  const {
    triggered: triggeredOverviewAGP,
  } = useNavAction({ name: 'OverviewAGP' }, { category });

  const { onPage: onPageApp } = useNavigation('App');
  const { onPage: onPageReport } = useNavigation('Report');

  return (
    <div {...ex(['Page', 'Overview'], rest)}>
      <PageContent {...rest}>
        <VBox full>
          <HBox full>
            <Section
              fullunset
              {...{
                caption: T('혈당'),
                options: (
                  <DataRatio {...{ data_reliability, data_reliability_yn }} />
                ),
              }}
            >
              <GlycemicIndexBox  {...rest} {...{ data }} />
            </Section>
            <Section
              {...ex('TabSection')}
              {...{
                caption: (
                  <OverviewTabs {...{ category, data }} />
                ),
                options: !triggeredOverviewAGP && (
                  <>
                    <div />
                    <HBox>
                      <Dot {...{ color: '#FF995A' }}>
                        <div>
                          고혈당
                        </div>
                      </Dot>
                      <Dot {...{ color: '#756CE4' }}>
                        <div>
                          저혈당
                        </div>
                      </Dot>
                    </HBox>
                  </>
                ),
                direction: DIRECTION_HORIZONTAL,
              }}
            >
              <Segment full>
                <PageOutlet
                  {...{
                    renderAll,
                    category,
                    pages,
                  }}
                />
              </Segment>
            </Section>
          </HBox>
          <HBox full>
            <Section
              {...{
                caption: (
                  <FocusableButton {...{ onClick: onPageReport('ReportDiet', onPageApp('Report')) }}>
                    {T('식사')}
                  </FocusableButton>
                ),
                options: (
                  <DataRatio>
                  {meal_cnt != null && meal_day_cnt != null && T('{0} 건 / {1} 일', meal_cnt, meal_day_cnt)}
                </DataRatio>

                ),
              }}
            >
              <DietBox {...rest}  {...{ data, onClick: onPageReport('ReportDiet', onPageApp('Report')) }} />
            </Section>
            <Section
              {...{
                caption: (
                  <FocusableButton {...{ onClick: onPageReport('ReportExercise', onPageApp('Report')) }}>
                    {T('활동')}
                  </FocusableButton>
                ),
                options: (
                  <DataRatio {...{ data_reliability: active_data_reliability }} />
                ),
              }}
            >
              <ExerciseBox {...rest}  {...{ data, onClick: onPageReport('ReportExercise', onPageApp('Report')) }} />
            </Section>
            <Section
              {...{
                caption: (
                  <FocusableButton {...{ onClick: onPageReport('ReportInsulin', onPageApp('Report')) }}>
                    {T('인슐린')}
                  </FocusableButton>
                ),
                options: (
                  <DataRatio {...{ data_reliability: insulin_data_reliability }} />
                ),
              }}
            >
              <InsulinBox {...rest}  {...{ data, onClick: onPageReport('ReportInsulin', onPageApp('Report')) }} />
            </Section>
          </HBox>
          <Division>
            <DrGuideBox {...rest}  {...{ data }} />
          </Division>
        </VBox>
      </PageContent>
    </div >
  );
}
